import {t} from 'i18next';
import {ReactElement} from 'react';
import {IconNames} from '../common/aur-icon/AurIcon';
export interface IGridColDef {
  name: string;
  label: string;
  dataType: string;
  id?: string | number;
  UIDataType?: string;
  fieldId?: number;
}

export const getDefaultDocListColumns = (): any[] => [
  {
    name: 'documentid',
    label: t('ecaDocList.columns.documentID'),
    dataType: 'keyword',
    UIDataType: 'text',
    isSortable: true,
  },
  {
    name: 'file_type',
    label: t('ecaDocList.columns.fileType'),
    dataType: 'keyword',
    UIDataType: 'text',
    isSortable: true,
  },
  {
    name: 'confidence_score',
    label: t('ecaDocList.columns.confidence'),
    dataType: 'number',
    UIDataType: 'number',
    isSortable: true,
  },
  {
    name: 'family_relationship',
    label: t('ecaDocList.columns.familyRelationship'),
    dataType: 'keyword',
    UIDataType: 'text',
    isSortable: true,
  },
  {
    name: 'custodian_displayname',
    label: t('ecaDocList.columns.custodianName'),
    dataType: 'keyword',
    UIDataType: 'text',
    isSortable: true,
  },
  {
    name: 'from',
    label: t('ecaDocList.columns.from'),
    dataType: 'text',
    UIDataType: 'text',
    isSortable: true,
  },
  {
    name: 'email_subject',
    label: t('ecaDocList.columns.emailSubject'),
    dataType: 'text',
    UIDataType: 'text',
    isSortable: true,
  },
  {
    name: 'filename',
    label: t('ecaDocList.columns.fileName'),
    dataType: 'text',
    UIDataType: 'text',
    isSortable: true,
  },
  {
    name: 'family_date',
    label: t('ecaDocList.columns.familyDate'),
    dataType: 'date',
    UIDataType: 'date',
    isSortable: true,
  },
];

export const defaultSortOrder = [
  {
    column: 'documentid',
    direction: 'asc',
    name: 'documentid',
    label: 'DocumentID',
    dataType: 'keyword',
    UIDataType: 'text',
  },
];

export const nlpDefaultSortOrder = [
  {
    column: 'confidence_score',
    direction: 'desc',
    name: 'confidence_score',
    label: 'Confidence',
    dataType: 'number',
  },
];

export interface docListResponseType {
  id: string;
  documentid: string;
  confidence_score?: number;
  all_custodians?: string;
  from?: string;
  email_subject?: string;
  filename?: string;
  file_type?: string;
  family_date?: string;
  family_relationship?: string;
  custid?: string;
  canHaveSummary?: string;
  summaryText?: string;
  nlpSummary?: boolean;
  loadingSummary?: boolean;
  nlp_summary_text?: string;
  nlpNotEnabled?: boolean;
}
export type DetailPanelContentProps = {
  row: docListResponseType;
  handleRowExpansion: (id: string) => void;
};

export interface ecaOverlayResponseType {
  id: string;
  overlayName: string;
  status: string;
  percentComplete: number;
  summaryText?: string;
  createdBy: string;
  dateStarted: string;
  dateCompleted: string;
}
export interface ecaExportResponseType {
  id: any;
  exportName: string;
  exportId?: string;
  ecaExportId: number;
  exportType: string;
  errorMessage?: string;
  status: string;
  percentComplete: number;
  totalDocExported?: string | number;
  exportFieldUsed: string;
  tagUsed: string;
  fileSize?: string | number;
  filePath?: string;
  exportDateTime: string;
  exportedBy: string;
  isLoadedToReviewPlatform: boolean;
  loadedMarkedBy: string;
  loadedOnTime: string;
  promotionNumber: string;
}
export enum FileType {
  CALENDER_ENTRY = 'calendar entry',
  CHAT_MESSAGES = 'chat messages',
  CHAT_CONVERSATIONS = 'chat conversations',
  CONTAINER = 'container',
  CONTACT = 'contact',
  DATABASE = 'database',
  DOCUMENT = 'document',
  WORD_PROCESSOR_DOCUMENT = 'Word Processor Document',
  DRAWING = 'drawing',
  EMAIL = 'email',
  IMAGE = 'image',
  LOG = 'log',
  MULTIMEDIA = 'multimedia',
  NO_DATA = 'no data',
  OTHER_DOCUMENT = 'other document',
  PRESENTATION = 'presentation',
  SPREADSHEET = 'spreadsheet',
  SYSTEM_FILE = 'system file',
  SYSTEM = 'system',
  UNRECOGNIZED = 'unrecognized',
  UNKNOWN = 'unknown',
}

export type FileTypeToIconMap = {
  [key in FileType]: IconNames;
};

export const fileTypeToIconMap: FileTypeToIconMap = {
  [FileType.CALENDER_ENTRY]: IconNames.CalendarIcon,
  [FileType.CHAT_MESSAGES]: IconNames.ChatIcon,
  [FileType.CHAT_CONVERSATIONS]: IconNames.ChatIcon,
  [FileType.CONTAINER]: IconNames.ContainerIcon,
  [FileType.CONTACT]: IconNames.ContactIcon,
  [FileType.DATABASE]: IconNames.DatabaseIcon,
  [FileType.DOCUMENT]: IconNames.DocumentIcon,
  [FileType.WORD_PROCESSOR_DOCUMENT]: IconNames.DocumentIcon,
  [FileType.DRAWING]: IconNames.DrawingIcon,
  [FileType.EMAIL]: IconNames.EmailIcon,
  [FileType.IMAGE]: IconNames.ImageIcon,
  [FileType.LOG]: IconNames.LogIcon,
  [FileType.MULTIMEDIA]: IconNames.MultimediaIcon,
  [FileType.NO_DATA]: IconNames.NoDataIcon,
  [FileType.OTHER_DOCUMENT]: IconNames.OtherDocumentIcon,
  [FileType.PRESENTATION]: IconNames.PresentationIcon,
  [FileType.SPREADSHEET]: IconNames.SpreadsheetIcon,
  [FileType.SYSTEM_FILE]: IconNames.SystemFileIcon,
  [FileType.SYSTEM]: IconNames.SystemFileIcon,
  [FileType.UNRECOGNIZED]: IconNames.NoDataIcon,
  [FileType.UNKNOWN]: IconNames.NoDataIcon,
};

export const FAMILY_STATUS = {
  P: 'P',
  C: 'C',
  S: 'S',
  PC: 'PC',
};
export interface ArrayItemType {
  name: string;
  label: string;
  dataType: string;
  id: string | number;
  UIDataType?: string;
  isSortable?: boolean;
}

export interface SortItemType {
  fieldValue: ArrayItemType;
  sortValue: ArrayItemType;
  id: string | number;
}

export interface SortableItemProps {
  item: ArrayItemType | SortItemType;
  children: ReactElement;
  className?: string;
  elementType?: string;
  handleToggle?: (value: ArrayItemType) => void;
  selected?: boolean;
  disabled?: boolean;
}

export interface MockDrageEndEvent {
  active: {id: string};
  over: {id: string};
}

interface Metadata {
  name: string;
  value: string | number;
}
export interface IDocListResponse {
  data: {
    docList: Array<{
      id: string;
      docId: string;
      metadata: Metadata[];
      text: string;
    }>;
    totalHits: number;
    docSetId?: string;
  };
  meta: {
    status: string;
    message: string;
    service: string;
    timeStamp: string;
  };
}
export interface FormattedItem {
  id: string;
  documentid: string;
  [key: string]: string | number;
}
export interface IFilterSet {
  linkOperator: string;
  items: (
    | {
        column: string;
        operator: string;
        value: string | number | undefined;
      }
    | {
        linkOperator: string;
        items: {
          column: string;
          operator: string;
          value: string | number | undefined;
        }[];
      }
  )[];
}

export interface IDocListReqBody {
  metaDataFields: string[];
  sortOrder: Array<{
    column: string;
    direction: string;
  }>;
  filterSet: IFilterSet;
  docSetId?: number;
}

export interface ISavedSearchReqBody {
  sortOrder: Array<{
    column: string;
    direction: string;
  }>;
  scope?: {
    scopeType: string;
    scopeId: string;
    scopeName: string;
  };
  columnOrder: string[];
  applyFilter: boolean;
  filterSet?: IFilterSet;
  name: string;
  notes: string;
  isPublicFlag: boolean;
  type: string;
  queryBuilderFlag: boolean;
  dtSyntaxQuery: string;
  noScopeDtSyntaxQuery: string;
  groupId?: string;
  relationalGroupFieldList: number[];
  indexName: string;
  fieldTemplateId: string;
  query?: string | object;
  jsonLogicQuery?: string;
  filteredDocCount?: number;
}
export interface IUpdateSavedSearchReqBody {
  name: string;
  parentGroupId: string;
}

export interface IDocListExportReqBody {
  docIdList?: string[];
  filterSet: IFilterSet;
  fieldIds: number[];
  sortOrder?: {
    column: string;
    direction: string;
  }[];
}
